import { Typography, Box, Button } from "@mui/material";
import styles from "../../../index.module.scss";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import TableComponent from "../../../../components/TableComponent";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState, appActions } from "../../../../store/app";
import AddIcon from "@mui/icons-material/Add";
import Storage from "../../../../utils/storage";
import LoadingContainer from "../../../../components/LoadingContainer";
import { useTranslation } from "../../../../i18n";
import PopupMenu from "../../../../components/PopupMenu";
import ConfirmModal from "../../../../components/ConfirmModal";
import { deleteAction } from "../../../../store/app/appActions";
import SearchComponent from "../../../../components/SearchComponent";
import ChipComponent, { ChipData } from "../../../../components/ChipComponent";
import { LoadingButton } from "@mui/lab";
import { expensesActions, ExpensesState } from "../../../../store/expenses";
import TreatmentView from "./TreatmentView";
import FilterTreatment from "./FilterTreatment";
import AddTreatment from "./AddTreatment";
import {
  Treatment,
  treatmentColumns,
  TreatmentRow,
} from "../../../../interfaces/Expenses/treatment";
import { deleteTreatmentService } from "../../../../store/expenses/treatment/treatmentService";
import {
  exportTreatmentAction,
  getTreatmentsAction,
  searchTreatmentAction,
} from "../../../../store/expenses/treatment/treatmentActions";
import { numberWithCommas } from "../../../../utils/functions";

const Treatments = () => {
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(50);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [query, setQuery] = useState("");
  const [isInit, setIsInit] = useState(true);
  const dispatch = useDispatch();
  const appState: AppState = useSelector((state: any) => state.app);
  const expensesState: ExpensesState = useSelector(
    (state: any) => state.expenses
  );
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [chipData, setChipData] = useState([]);
  const [treatment, setTreatment] = useState<any>();
  const [viewTreatment, setViewTreatment] = useState<boolean>();
  const open = Boolean(anchorEl);
  const token = Storage.getToken();
  const { t } = useTranslation();

  console.log("Treatment reload");

  useEffect(() => {
    dispatch(
      getTreatmentsAction(
        `?page=${page}&sort=-createdAt&limit=${rowsPerPage}`,
        token
      )
    );
  }, []);

  useEffect(() => {
    if (!expensesState.fetchedTreatments) {
      dispatch(
        getTreatmentsAction(
          `?page=${page}&sort=-createdAt&limit=${rowsPerPage}${query}`,
          token
        )
      );
    }
  }, [
    dispatch,
    expensesState.fetchedTreatments,
    page,
    query,
    rowsPerPage,
    token,
  ]);

  useEffect(() => {
    if (!appState.isFetching) {
      setCount(appState.count);
    }
  }, [appState.isFetching, appState.count]);

  useEffect(() => {
    if (chipData.length > 0) {
      let queryString = "";
      chipData.forEach((data: any) => {
        queryString += `&${data.id}=${data.filter}`;
      });
      setQuery(queryString);
      dispatch(expensesActions.setFetchedTreatments(false));
    } else if (chipData.length === 0 && query !== "") {
      setQuery("");
      dispatch(expensesActions.setFetchedTreatments(false));
    }
  }, [chipData, dispatch, query]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (searchText) {
        dispatch(searchTreatmentAction(`?text=${searchText}`, token));
        setIsInit(false);
      } else {
        if (!appState.isFetching && !isInit) {
          dispatch(expensesActions.setFetchedTreatments(false));
        }
      }
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [appState.isFetching, dispatch, isInit, searchText, token]);

  const createData = (treatment: Treatment): TreatmentRow => {
    console.log("tttttt ", treatment);
    return {
      date: treatment?.communicationDate?.substring(0, 10),
      category: t(`${treatment?.category}`),
      pig: treatment?.category === "piglet" ? "icyana" : treatment?.pig?.earTag,
      sickness: treatment?.sickness?.name,
      cost: `${numberWithCommas(treatment.cost)} Rw`,
      action: (
        <button
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
            setTreatment(treatment);
            setAnchorEl(event.currentTarget);
          }}
          className={styles.actionsIcon}
        >
          •••
        </button>
      ),
    };
  };

  const handlePageChange = (event: unknown, newPage: number) => {
    setPage(newPage);
    dispatch(expensesActions.setFetchedTreatments(false));
  };

  const filterHandler = (filterData: any) => {
    setChipData(filterData);
  };

  const handleChipDelete = (chipToDelete: ChipData) => {
    setChipData((chips) =>
      chips.filter((chip: ChipData) => chip.key !== chipToDelete.key)
    );
  };

  const exportExcelHandler = () => {
    dispatch(exportTreatmentAction("?limit=1000", token, t("Treatments")));
  };

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    dispatch(expensesActions.setFetchedTreatments(false));
  };

  const deleteStaffHandler = () => {
    dispatch(
      deleteAction(
        deleteTreatmentService,
        treatment?._id,
        token,
        t("staff"),
        () => {},
        () => dispatch(expensesActions.setFetchedTreatments(false))
      )
    );
  };

  const rows = expensesState.treatments?.map((treatment: Treatment) =>
    createData(treatment)
  );

  return (
    <>
      <Box className={styles.topContainer}>
        <Box>{t("welcome")}</Box>
        <Box className={styles.dFlex}>
          <SearchComponent setSearchText={setSearchText} />
          <LoadingButton
            variant="contained"
            startIcon={<SaveAltIcon />}
            loading={appState.isExportingExcel}
            onClick={exportExcelHandler}
            className={styles.exportExcelButton}
          >
            {t("exportExcel")}
          </LoadingButton>
        </Box>
      </Box>
      {appState.isFetching && <LoadingContainer />}
      {!appState.isFetching && (
        <>
          {chipData.length > 0 && (
            <ChipComponent
              chipData={chipData}
              handleDelete={handleChipDelete}
            />
          )}
          <Box className={styles.tableTopActions}>
            <Box>
              <Typography>{t("Treatments")}</Typography>
            </Box>
            <Box>
              <Button
                onClick={() => dispatch(appActions.setOpenFilter(true))}
                startIcon={<AddIcon />}
              >
                {t("filter")}
              </Button>
              <Button
                onClick={() =>
                  dispatch(
                    appActions.setOpenForm({ open: true, action: "add" })
                  )
                }
                startIcon={<AddIcon />}
              >
                {t("addNew")}
              </Button>
            </Box>
          </Box>
          <TableComponent
            rows={rows}
            columns={treatmentColumns}
            count={count}
            page={page}
            rowsPerPage={rowsPerPage}
            handlePageChange={handlePageChange}
            handleRowsPerPageChange={handleRowsPerPageChange}
          />
          {open && (
            <PopupMenu
              anchorEl={anchorEl}
              onClose={() => setAnchorEl(null)}
              onView={() => setViewTreatment(true)}
              onUpdate={() =>
                dispatch(
                  appActions.setOpenForm({ open: true, action: "update" })
                )
              }
              onDelete={() => dispatch(appActions.setIsDeleting(true))}
            />
          )}
          {appState.isDeleting && (
            <ConfirmModal
              onConfirm={() => deleteStaffHandler()}
              content={`${t("confirmDeleteDesc")} ${
                treatment?.sickness?.name
              } ?`}
            />
          )}
          {appState.openForm.open && <AddTreatment treatment={treatment} />}
          {appState.openFilter && (
            <FilterTreatment
              open={appState.openFilter}
              close={() => dispatch(appActions.setOpenFilter(false))}
              filterHandler={filterHandler}
            />
          )}
          {viewTreatment && (
            <TreatmentView
              open={viewTreatment}
              onClose={() => setViewTreatment(false)}
              treatment={treatment}
            />
          )}
        </>
      )}
    </>
  );
};

export default Treatments;
